<template>
  <el-drawer
    title=""
    :visible.sync="drawerVisible"
    direction="btt"
    :wrapperClosable="true"
    :close-on-press-escape="false"
    :show-close="false"
    size="72%"
    @close="closeDrawer"
  >
    <div class="tabs" slot="title">
      <div class="tabs-item" :class="tabsActive === 'highlight' ? 'tabs-item-active' : ''" @click="changeTabs('highlight')">标记</div>
      <div class="tabs-item" :class="tabsActive === 'note' ? 'tabs-item-active' : ''" @click="changeTabs('note')">笔记</div>
    </div>
    <div class="mark-box">
      <template v-if="tabsActive === 'highlight'">
        <div v-show="!highlightList.length" class="blank-box">暂无数据</div>
        <highlight
          :highlightList="highlightList"
          v-show="highlightList.length"
          @delRecordLi="delRecordLi"
          @mindMapAdd="mindMapAdd"
          @chapterChange="chapterChange"
          @closeDrawer="closeDrawer"
          @tableTabChange="tableTabChange"
        ></highlight>
      </template>
      <template v-if="tabsActive === 'note'">
        <div v-show="!noteList.length" class="blank-box">暂无数据</div>
        <noteList
          :noteList="noteList"
          :activeNote="activeNote"
          v-show="noteList.length"
          @delRecordLi="delRecordLi"
          @mindMapAdd="mindMapAdd"
          @editNote="editNote"
          @chapterChange="chapterChange"
          @tableTabChange="tableTabChange"
        ></noteList>
      </template>
    </div>
  </el-drawer>
</template>
<script>
  import highlight from './highlight.vue'
  import noteList from './noteList.vue'
  export default {
    name: "markDrawer",
    components: {
      highlight,
      noteList,
    },
    props: {
      //drawer 是否展示
      visible: {
        type: Boolean,
        default: false,
      },
      highlightList: {
        type: Array,
        default: () => {
          return [];
        }
      },
      noteList: {
        type: Array,
        default: () => {
          return [];
        }
      },
      activeNote: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        tabsActive: 'highlight',
        drawerVisible: false,
      }
    },
    watch: {
      visible(newVal) {
        this.drawerVisible = newVal
      }
    },
    methods: {
      changeTabs(type) {
        this.tabsActive = type;
      },
      delRecordLi(id) {
        this.$emit('delRecordLi', id)
      },
      mindMapAdd(item) {
        this.$emit('mindMapAdd', item)
      },
      chapterChange(index) {
        this.$emit('chapterChange', index, true)
        this.closeDrawer()
      },
      tableTabChange(tableKey, tableTabKey) {
        this.$emit('tableTabChange', tableKey, tableTabKey)
      },
      editNote(id) {
        this.$emit('editNote', id)
      },
      // 关闭弹窗
      closeDrawer() {
        this.$emit('closeDrawer', 'mark')
      },
    }
  }
</script>

<style scoped lang="scss">
.tabs{
  height: 112rem;
  line-height: 112rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-bottom: 2rem solid #E3E3E3;
  font-size: 36rem;
  padding: 0 40rem;

  .tabs-item{
    color: #333;
  }

  .tabs-item-active{
    color: #0FC29A;
    font-weight: bold;
    position: relative;

    &:after{
      content: '';
      width: 100%;
      height: 6rem;
      position: absolute;
      bottom: -3rem;
      left: 50%;
      transform: translateX(-50%);
      background: #0FC29A;
      border-radius: 3rem;
    }
  }
}
.mark-box{
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;

  .blank-box {
    margin: 180rem auto 60rem;
    padding-top: 30%;
    font-size: 28rem;
    text-align: center;
    color: #a5b3c6;
    width: 450rem;
    height: 300rem;
    background: url("~@/assets/images/common/blank_pic.png") center center no-repeat;
    background-size: contain;
  }
}
/deep/.el-drawer {
  border-radius: 20rem 20rem 0 0;
  .el-drawer__header {
    margin: 0;
    padding: 0;
  }
  .el-drawer__body {
    padding: 0;
    padding-bottom: 128rem;
  }
}
</style>